import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { eventTypeSelector, useGetProfileQuery } from 'root-api'

// Routes that don't load an eventType / landingPage / routingForm and therefore
// need useProfile to fetch the profile directly so consumers like
// useOrganizationUuid (and the OnetrustWrapper that depends on it) can resolve.
const PROFILE_FETCH_PATHS = new Set([
  '/:profileSlug',
  '/:profileSlug/invoices/:invoiceUuid',
])

export const useProfile = (profileFromProps) => {
  const eventType = useSelector(eventTypeSelector)
  const { params, path } = useRouteMatch()
  const {
    data: profileFromRequest,
    isLoading
  } = useGetProfileQuery(
    { slug: params.profileSlug },
    { skip: !PROFILE_FETCH_PATHS.has(path) }
  )
  const profile = profileFromProps || profileFromRequest || eventType?.profile

  if (isLoading) return undefined
  if (!profile) return null
  return profile
}
